import React from 'react';
import './index.scss';

function CardCategory(props) {
    return(
        <div class="col card-category mb-4 mx-auto mx-sm-0">
            <div class="card mx-1">
                <img src={props.data.card.imageurl} class="card-img-top" alt="..."/>
                <div class="card-img-overlay d-flex align-items-end">
                    <h5 class="card-title">Name</h5>
                </div>
            </div>
                </div>
    )
}

export default CardCategory;